(function($) {
	formHelper.addRule({
		form: '.form-manage-promotion',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}
			},
			ERROR_MESSAGE_FIVE: function() {
				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}
	});
})(jQuery);

jQuery(function initToolsManagePromotion($) {
	$('.manage-promotion-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-promotion');

		
		// Date Booking From Range
		// ------------------
		var $bookingFromStart = $('#booking-from-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var bookingFromStartPicker = $bookingFromStart.pickadate('picker');

		var $bookingFromEnd = $('#booking-from-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var bookingFromEndPicker = $bookingFromEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( bookingFromStartPicker.get('value') ) {
			bookingFromEndPicker.set('min', bookingFromStartPicker.get('select'));
		}
		
		if ( bookingFromEndPicker.get('value') ) {
			bookingFromStartPicker.set('max', bookingFromEndPicker.get('select'));
		}

		// When something is selected, update the "bookingFromStart" and "bookingFromEnd" limits.
		bookingFromStartPicker.on('set', function(event) {
			if ( event.select ) {
				bookingFromEndPicker.set('min', bookingFromStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				bookingFromEndPicker.set('min', false);
			}
		});

		bookingFromEndPicker.on('set', function(event) {
			if ( event.select ) {
				bookingFromStartPicker.set('max', bookingFromEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				bookingFromStartPicker.set('max', false);
			}
		});


		// Date Booking To Range
		// ------------------
		var $bookingToStart = $('#booking-to-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var bookingToStartPicker = $bookingToStart.pickadate('picker');

		var $bookingToEnd = $('#booking-to-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var bookingToEndPicker = $bookingToEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( bookingToStartPicker.get('value') ) {
			bookingToEndPicker.set('min', bookingToStartPicker.get('select'));
		}
		
		if ( bookingToEndPicker.get('value') ) {
			bookingToStartPicker.set('max', bookingToEndPicker.get('select'));
		}

		// When something is selected, update the "bookingToStart" and "bookingToEnd" limits.
		bookingToStartPicker.on('set', function(event) {
			if ( event.select ) {
				bookingToEndPicker.set('min', bookingToStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				bookingToEndPicker.set('min', false);
			}
		});

		bookingToEndPicker.on('set', function(event) {
			if ( event.select ) {
				bookingToStartPicker.set('max', bookingToEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				bookingToStartPicker.set('max', false);
			}
		});

		

		// Date Restriction From Range
		// ------------------
		var $restrictionFromStart = $('#restriction-from-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromStartPicker = $restrictionFromStart.pickadate('picker');

		var $restrictionFromEnd = $('#restriction-from-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromEndPicker = $restrictionFromEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionFromStartPicker.get('value') ) {
			restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
		}
		
		if ( restrictionFromEndPicker.get('value') ) {
			restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionFromStart" and "restrictionFromEnd" limits.
		restrictionFromStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromEndPicker.set('min', false);
			}
		});

		restrictionFromEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromStartPicker.set('max', false);
			}
		});


		// Date Restriction To Range
		// ------------------
		var $restrictionToStart = $('#restriction-to-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionToStartPicker = $restrictionToStart.pickadate('picker');

		var $restrictionToEnd = $('#restriction-to-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionToEndPicker = $restrictionToEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionToStartPicker.get('value') ) {
			restrictionToEndPicker.set('min', restrictionToStartPicker.get('select'));
		}
		
		if ( restrictionToEndPicker.get('value') ) {
			restrictionToStartPicker.set('max', restrictionToEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionToStart" and "restrictionToEnd" limits.
		restrictionToStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionToEndPicker.set('min', restrictionToStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionToEndPicker.set('min', false);
			}
		});

		restrictionToEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionToStartPicker.set('max', restrictionToEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionToStartPicker.set('max', false);
			}
		});		
	});
});

jQuery(function initToolsManagePromotionAddForm($) {
	$('.add-promotion-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-add-promotion');		

		// Promotion Date Range
		// ------------------
		var $promotionDateStart = $('#promotion-start-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var promotionDateStartPicker = $promotionDateStart.pickadate('picker');

		var $promotionDateEnd = $('#promotion-end-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var promotionDateEndPicker = $promotionDateEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( promotionDateStartPicker.get('value') ) {
			promotionDateEndPicker.set('min', promotionDateStartPicker.get('select'));
		}
		
		if ( promotionDateEndPicker.get('value') ) {
			promotionDateStartPicker.set('max', promotionDateEndPicker.get('select'));
		}

		// When something is selected, update the "promotionDateStart" and "promotionDateEnd" limits.
		promotionDateStartPicker.on('set', function(event) {
			if ( event.select ) {
				promotionDateEndPicker.set('min', promotionDateStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				promotionDateEndPicker.set('min', false);
			}
		});

		promotionDateEndPicker.on('set', function(event) {
			if ( event.select ) {
				promotionDateStartPicker.set('max', promotionDateEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				promotionDateStartPicker.set('max', false);
			}
		});

		// Date Restriction From Range
		// ------------------
		var $restrictionFromStart = $('#travel-restriction-date-from').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromStartPicker = $restrictionFromStart.pickadate('picker');

		var $restrictionFromEnd = $('#travel-restriction-date-to').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromEndPicker = $restrictionFromEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionFromStartPicker.get('value') ) {
			restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
		}
		
		if ( restrictionFromEndPicker.get('value') ) {
			restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionFromStart" and "restrictionFromEnd" limits.
		restrictionFromStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromEndPicker.set('min', false);
			}
		});

		restrictionFromEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromStartPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsManagePromotionEditForm($) {
	$('.edit-promotion-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-promotion');

		// Promotion Date Range
		// ------------------
		var $promotionDateStart = $('#promotion-start-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var promotionDateStartPicker = $promotionDateStart.pickadate('picker');

		var $promotionDateEnd = $('#promotion-end-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var promotionDateEndPicker = $promotionDateEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( promotionDateStartPicker.get('value') ) {
			promotionDateEndPicker.set('min', promotionDateStartPicker.get('select'));
		}
		
		if ( promotionDateEndPicker.get('value') ) {
			promotionDateStartPicker.set('max', promotionDateEndPicker.get('select'));
		}

		// When something is selected, update the "promotionDateStart" and "promotionDateEnd" limits.
		promotionDateStartPicker.on('set', function(event) {
			if ( event.select ) {
				promotionDateEndPicker.set('min', promotionDateStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				promotionDateEndPicker.set('min', false);
			}
		});

		promotionDateEndPicker.on('set', function(event) {
			if ( event.select ) {
				promotionDateStartPicker.set('max', promotionDateEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				promotionDateStartPicker.set('max', false);
			}
		});

		// Date Restriction From Range
		// ------------------
		var $restrictionFromStart = $('#travel-restriction-date-from').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromStartPicker = $restrictionFromStart.pickadate('picker');

		var $restrictionFromEnd = $('#travel-restriction-date-to').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromEndPicker = $restrictionFromEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionFromStartPicker.get('value') ) {
			restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
		}
		
		if ( restrictionFromEndPicker.get('value') ) {
			restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionFromStart" and "restrictionFromEnd" limits.
		restrictionFromStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromEndPicker.set('min', false);
			}
		});

		restrictionFromEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromStartPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsManagePromotionResults($) {
	$('.manage-promotion-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-promotion-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});

jQuery(function initEditPromotion($) {
	$('.edit-promotion-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-promotion');
		var $submitBtn             = $container.find('.btn-submit');
		var $copyBtn               = $container.find('.btn-copy');
		var $deleteBtn             = $container.find('.delete-button');

		$submitBtn.click(function() {
			$('#delete-promotion').val('no');
			$('#promo-status').val('edit');
		});

		$copyBtn.click(function() {
			$('#delete-promotion').val('no');
			$('#promo-status').val('copy');
			$form.submit();
		});

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue?");
			if (r === true) {
			    $('#delete-promotion').val('yes');
				$form.submit();
			}
		});
	});
});

jQuery(function($) {
	$('.js-promotion-actions').change(function() { 
		if($(this).val() !== '') {
			document.location.href = $(this).val(); 
		}
	})
});